import React from 'react';
import TableLink from "v4/components/utils/TableLink/TableLink";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";

export default function ProspectsListingRowActions({rowId}) {
    const { getDefaultProspectTab } = useNavigation();
    const defaultTab = getDefaultProspectTab();

    if (!defaultTab?.url) return null;

    return (
        <TableLink href={`/${resolveUrl(defaultTab.url, { prospect: rowId })}`}/>
    )
}
